import { useMemo } from "react";

import { useFiltersConfigContext } from "app/pages/sales-intelligence/modules/advanced-search-filtering/context/FiltersConfigContext";
import { buildFilterTitleByKey } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/buildFilterTitleByKey";

/** `filterKey → title` map from the Lead-Gen filters config, for labelling territory filter chips. */
export const useFilterTitleByKey = (): ReadonlyMap<string, string> => {
    const { filtersList } = useFiltersConfigContext();

    return useMemo(() => buildFilterTitleByKey(filtersList), [filtersList]);
};
